<template lang="pug">
  div(:class="$style.wrap")
    label 余白
    a-dropdown(v-model="visible")
      a-input-number(
        :value="valueString"
        :class="$style.input"
        :min="0"
        :data-active="visible"
        @change="handleInput"
      )
      div(:class="$style.select", slot="overlay")
        div(
          v-for="v in [0, 5, 10, 15, 20, 25, 30, 35, 40]"
          :key="v"
          :class="$style.selectItem",
          @click="changeSize(v)",
          :active="value === v"
        ) {{v}}
    //- a-auto-complete(
    //-   :data-source="['1', '2', '5', '10', '15', '20', '30']"
    //-   placeholder="input here"
    //-   :class="$style.toolSize"
    //-   :value="valueString"
    //-   :dropdownMenuStyle="{ textAlign: 'center' }"
    //- )
</template>
<style lang="postcss" module>
  .wrap {
    display: flex;
    align-items: center;
  }
  .input {
    position: relative;
    font-size: 1.8rem;
    font-weight: bold;
    color: var(--black);
    text-align: center;
    width: 32px;
    background-color: inherit;
    border: 1px solid transparent;
    box-shadow: none;
    padding: 0;
    cursor: pointer;
    &[data-active],
    &:hover {
      border: 1px solid var(--gray-lighter);
      box-shadow: none;
    }
    & :global(.ant-input-number-input) {
      text-align: center;
      padding: 0;
    }
    & :global(.ant-input-number-handler-wrap) {
      display: none;
    }
  }
  .select {
    position: absolute;
    top: 100%;
    left: 50%;
    background-color: color-mod(#fff a(90%));
    border-radius: 6px;
    transform: translate(-50%, 20px);
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      top: -20px;
      left: 0;
      width: 100%;
      height: 20px;
    }
  }
  .selectItem {
    font-size: 1.4rem;
    font-weight: normal;
    text-align: center;
    padding: 0.5em 1em;
    cursor: pointer;
    &:hover {
      background-color: var(--gray-lighter);
    }
    &[active] {
      background-color: var(--gray-lighter);
    }
  }

</style>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    valueString() {
      return String(this.value)
    },
  },
  methods: {
    changeSize(value) {
      this.$emit('change', value)
    },
    handleInput(e) {
      this.changeSize(e)
    },
  },
}
</script>
